import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { localize } from 'helpers/translator'
import lessonTypes from 'helpers/enums/lessonTypes'
import HintTooltipController from 'components/tooltip/hint/hint_tooltip_controller'
import VideoFooter from 'components/npp/videoNppFooter'
import QuickLaunchFooter from 'components/npp/quickLaunchFooter'
import tooltipTypes from 'helpers/enums/tooltipTypes'

import styles from './npp.scss'

import imageNppThumb from '../../assets/components/npp/npp_thumbnail__img.png'

class Npp extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			mounted: false,
			isHovering: false,
		}
	}

	getTransitionsNames() {
		switch (this.props.animType) {
			case 'no_anim':
			case '':
				return {enter: 'no_anim', leave: 'no_anim'}
			case 'in':
				return {enter: styles.anim_in_enter, leave: styles.anim_in_leave}
		}
	}

	getLongLabelClass() {
		switch (this.props.long_label.color) {
			case 'green':
				return 'npp_long_label--green'
				break
			case 'orange':
				return 'npp_long_label--orange'
				break
			case 'blue':
				return 'npp_long_label--blue'
				break
			case 'red':
				return 'npp_long_label--red'
				break
			default:
				return ''
		}
	}

	componentDidMount() {
		this.setState({mounted: true})
	}

	handleHover = () => {
		this.setState({
			isHovering: true,
		})
	}

	handleMouseLeave = () => {
		this.setState({
			isHovering: false,
		})
	}

	render() {
		const imgStyle = {
			backgroundImage: 'url(' + this.props.lessonImage + ')',
		}

		const transitionNames = this.getTransitionsNames()

		let showNppLabel = false
		let showNppBundleLabel = false
		let nppLabelText = ''
		if (this.props.isNew === '1') {
			if (this.props.libraryObjectType === '3') {
				if (this.props.newLessonsAdded === 1) {
					nppLabelText = localize('npp_label_new_lesson_added')
					showNppLabel = true
				} else if (this.props.newLessonsAdded > 1) {
					nppLabelText = localize('npp_label_new_lessons_added')
					showNppLabel = true
				} else {
					nppLabelText = localize('npp_label_new_bundle')
					showNppBundleLabel = true
				}
			} else {
				nppLabelText = localize('npp_label_new_lesson')
				showNppLabel = true
			}
		}
		let gradesLabel = ''
		if (this.props.grades) {
			gradesLabel = this.props.grades.reduce((result, grade) => result ? (result + ', ' + grade.name) : grade.name, '')
		}

		return (
			<div styleName={classNames({
				npp: true,
				new: showNppLabel,
				new_bundle: showNppBundleLabel,
				highlight: this.props.isHighlighted,
				'z-index-order': this.props.tooltipType !== '' && this.props.tooltipType !== tooltipTypes.NONE,
				anim_in_enter: transitionNames.enter === styles.anim_in_enter,
				'anim_in_enter-active': transitionNames.enter === styles.anim_in_enter && this.props.active,
			})}
			onMouseEnter={this.handleHover}
			onMouseLeave={this.handleMouseLeave}
			>
				<span styleName='npp_label' >{nppLabelText}</span>
				{(this.props.header_type === 'store' || this.props.header_type === 'private_library') &&
						<div styleName='npp_txt'>
							<div styleName='npp_txt__left'>
								{ this.props.authorImage &&
										<img styleName='npp_txt__avatar npp_txt__avatar-store' src={this.props.authorImage} />
								}
							</div>
							<div styleName='npp_txt__center'>
								<h1 styleName='npp_txt__title' title={this.props.title}>{this.props.title}</h1>
								<p styleName='npp_txt__label' title={this.props.subtitle}>{this.props.subtitle}</p>
								{ !!this.props.showPriceThumb && this.props.is_free &&
										<p styleName='npp_txt__free'>{localize('npp_free')}</p>
								}
								{ !!this.props.showPriceThumb && !this.props.is_free &&
										<p styleName='npp_txt__label'>
											{this.props.strikethrough_price && <span styleName='npp_txt__label-through'>{'$' + this.props.strikethrough_price}</span>}
											<span>{'$' + this.props.price}</span>
										</p>
								}
							</div>
							{!!gradesLabel &&
									<div styleName='npp_txt__right'>
										<h1 styleName='npp_txt__title'>{localize('npp_activity_grades')}</h1>
										<p styleName='npp_txt__grades'>{gradesLabel}</p>
									</div>
							}
						</div>
				}
				{ this.props.header_type === 'library' &&
						<div styleName='npp_txt'>

							<div styleName='npp_txt__left'>
								{ this.props.authorImage &&
								<img styleName='npp_txt__avatar' src={this.props.authorImage} />
								}
							</div>
							<div styleName='npp_txt__center'>
								<h1 styleName='npp_txt__title' title={this.props.title}>{this.props.title}</h1>
								<p styleName='npp_txt__label'>{this.props.subtitle}</p>
								<p styleName='npp_txt__label'>{this.props.date} - <span styleName='npp_txt__label'>{this.props.size}MB</span></p>
							</div>
						</div>
				}
				<div styleName='npp_thumbnail'>
					<img styleName='npp_thumbnail__img npp_thumbnail__img_image_loader' src={imageNppThumb} onLoad={this.props.onLoad} />
					<svg styleName='npp_thumbnail__img' style={imgStyle} viewBox="0 0 236 177" width="236" height="177" >
						<rect width="236" height="177" x="0" y="0" fill="rgba(255,255,255,0)"></rect>
					</svg>
					{this.props.long_label.active &&
							<div styleName={classNames({
								npp_long_label: true,
								[this.getLongLabelClass()]: true,
							})}>{this.props.long_label.text}</div>}
				</div>
				{this.props.lessonType === lessonTypes.VIDEO &&
						<div styleName="npp-footer">
							<VideoFooter
								duration={this.props.videoDuration}
								isFromYoutube={this.props.isFromYoutube}
							/>
						</div>
				}
				{this.props.lessonType === lessonTypes.QUICK_LAUNCH &&
					<div styleName="npp-footer">
						<QuickLaunchFooter />
					</div>
				}
				{!this.props.shouldHideHover && this.props.children &&
				(this.state.isHovering || this.props.keep_hover) &&
					<div
						styleName={
							classNames({
								npp_hover: true,
								npp_hover_move: this.props.canDrag,
								npp_hover_transparent:
									this.props.transparent_hover,
								npp_hover_fixed: this.props.keep_hover,
							})
						}
					>
						{ this.props.children }
					</div>
				}
				<HintTooltipController
					type={this.props.tooltipType}
					entityUID={this.props.entityUID}
				/>
			</div>
		)
	}
}

Npp.propTypes = {
	isNew: PropTypes.bool,
	newLessonsAdded: PropTypes.number,
	keep_hover: PropTypes.bool,
	transparent_hover: PropTypes.bool,
	shouldHideHover: PropTypes.bool,
	animType: PropTypes.string,
	isHighlighted: PropTypes.bool,
	isOnTop: PropTypes.bool,
	header_type: PropTypes.string,
	long_label: PropTypes.object,
	title: PropTypes.string,
	subtitle: PropTypes.string,
	grades: PropTypes.array,
	showPriceThumb: PropTypes.bool,
	npp_hover: PropTypes.bool,
	canDrag: PropTypes.bool,
	tooltipType: PropTypes.string,
	lessonType: PropTypes.oneOf(Object.values(lessonTypes)),
	videoDuration: PropTypes.string,
	isFromYoutube: PropTypes.bool,
}

Npp.defaultProps = {
	isNew: false,
	newLessonsAdded: 0,
	keep_hover: false,
	transparent_hover: false,
	shouldHideHover: false,
	animType: 'no_anim',
	isHighlighted: false,
	isOnTop: false,
	header_type: 'library',
	long_label: {active: false},
	title: '',
	subtitle: '',
	grades: [],
	showPriceThumb: true,
	canDrag: false,
	tooltipType: '',
	lessonType: lessonTypes.REGULAR,
	isFromYoutube: false,
}

export default CSSModules(Npp, styles, {allowMultiple: true})
